import { ComponentPropsWithoutRef } from 'react';

// The DOM field name is hardcoded below (after the props spread), so forms
// registering the honeypot in RHF must use this exact key or the two drift.
// eslint-disable-next-line react-refresh/only-export-components
export const HONEYPOT_FIELD_NAME = 'website_url';

export const HoneypotInput = (props: ComponentPropsWithoutRef<'input'>) => (
  <input
    {...props}
    type="text"
    name={HONEYPOT_FIELD_NAME}
    tabIndex={-1}
    autoComplete="off"
    aria-hidden="true"
    style={{
      position: 'absolute',
      left: '-9999px',
      width: '1px',
      height: '1px',
      opacity: 0,
    }}
  />
);
